// Google Tag Manager — always loaded.
// Consent Mode v2 (analytics.liquid) controls which Google tags fire.
// Non-Google trackers (Hotjar, Clarity, Mida, Klaviyo) are loaded on
// demand by window.__achateTrackers only after explicit consent.
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-NHQT64M');
